import AppScrollbar from "_lib/AppScrollbar";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { styled } from "styled-components";

export const StyledAppLayout = styled(Layout)`
  width: 100%;
  height: 100%;
  position: fixed;
  overflow-x: hidden;
  overflow-y: hidden;
  background: ${({ theme }) => theme.palette.background.default};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    position: relative;
  }
`;

export const StyledAppLayoutMain = styled(Layout)`
  transition: all 0.1s linear;
  flex-shrink: 0;
  background: ${({ theme }) => theme.palette.background.default};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    position: absolute;
    top: ${({ theme }) => `${theme.header.height}px`};
    bottom: ${({ theme }) => `${theme.mobileMenu.height}px`};
    width: 100% !important;
    &.bottom-zero {
      bottom: 0px;
    }
  }
`;

export const StyledAppLayoutContent = styled(Content)`
  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    width: 100% !important;
  }
`;

export const StyledAppLayoutContentScrollbar = styled(AppScrollbar)`
  height: 100vh;
  padding: 32px 48px;
  overflow-x: hidden;
  background: ${({ theme }) => theme.palette.background.default};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    height: 100%;
    width: 100%;
    top: 0;
    padding: 16px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    overflow-x: hidden;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xxs}px) {
    padding: 10px;
  }
`;
